var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEnroller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 443.43 91.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#646569;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 127,
    y1: -43.19,
    x2: 312.81,
    y2: 142.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#41ad49"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.79,30.07A5.18,5.18,0,1,1,378,24.89,5.13,5.13,0,0,1,372.79,30.07Zm0-9.73a4.55,4.55,0,1,0,4.55,4.55A4.59,4.59,0,0,0,372.79,20.34ZM375,27.86h-.9l-1.56-2.54h-.83v2.54H371V21.92h1.69c1.18,0,2,.58,2,1.69a1.59,1.59,0,0,1-1.38,1.63Zm-2.41-5.31h-.87v2.14h.87c.68,0,1.34-.2,1.34-1.08S373.27,22.55,372.59,22.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.5,57.73H33.09V0H74.66V12H48.07V22.87H73.17v12H48.07V45.55H75.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.29,57.73H113.41V33.83c0-6-.93-10.6-7.07-10.6-6.42,0-8.18,5.21-8.18,11.81V57.73H83.29V11.89H98.16l-.09,6.6h.19A14.87,14.87,0,0,1,111.55,11c13.3,0,16.74,8.55,16.74,19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.5,25.55h-.65a12,12,0,0,0-5.39-1.12,8.74,8.74,0,0,0-6.88,3.35c-1.12,1.49-2.32,4.46-2.32,9.58V57.73H136.37V11.89h14.88l-.09,6.51h.19c2.6-5,6.42-7.34,11.34-7.34a10.7,10.7,0,0,1,4.65.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.13,58.75c-14.51,0-25.48-9-25.48-23.8s11-23.9,25.48-23.9,25.39,9.11,25.39,23.9S209.63,58.75,195.13,58.75Zm0-36c-6.6,0-10.41,5.11-10.41,11.9s3.81,11.9,10.41,11.9,10.42-5.11,10.42-11.9S201.64,22.77,195.13,22.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.82,57.73H227.94V0h14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.73,57.73H252.85V0h14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.67,38.39H290c.65,6.6,5.67,9.58,11.72,9.58a25.81,25.81,0,0,0,13.76-4.37l5.86,7.72c-1.49,1.12-7.53,7.44-21.76,7.44S275.16,50,275.16,34.85,286.32,11,299.89,11s23,9,23,22.41C322.86,35.69,322.67,38.39,322.67,38.39ZM309,29.93a9.24,9.24,0,0,0-9.39-9.21,9.34,9.34,0,0,0-9.48,9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360,25.55h-.65a12,12,0,0,0-5.39-1.12A8.74,8.74,0,0,0,347,27.79c-1.12,1.49-2.32,4.46-2.32,9.58V57.73H329.83V11.89h14.88l-.09,6.51h.19c2.6-5,6.42-7.34,11.34-7.34a10.7,10.7,0,0,1,4.65.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.16,12l-65.6,65.6c-6.08,6.08-14.93,6.22-15,6.22H0v7.27H352.55c.48,0,11.9-.1,20.15-8.35L443.43,12Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEnroller);
export default __webpack_public_path__ + "static/media/logo-enroller.30b0710f05bfda50ae16665624857353.svg";
export { ForwardRef as ReactComponent };